__turbopack_context__.v({
  "button": "phone-verification-module-scss-module__Czs-8G__button",
  "buttonSeparator": "phone-verification-module-scss-module__Czs-8G__buttonSeparator",
  "codeInfo": "phone-verification-module-scss-module__Czs-8G__codeInfo",
  "codeInput": "phone-verification-module-scss-module__Czs-8G__codeInput",
  "copy": "phone-verification-module-scss-module__Czs-8G__copy",
  "dialog": "phone-verification-module-scss-module__Czs-8G__dialog",
  "dialogCloseButton": "phone-verification-module-scss-module__Czs-8G__dialogCloseButton",
  "dialogContent": "phone-verification-module-scss-module__Czs-8G__dialogContent",
  "dialogOverlay": "phone-verification-module-scss-module__Czs-8G__dialogOverlay",
  "dialogTitle": "phone-verification-module-scss-module__Czs-8G__dialogTitle",
  "disabled": "phone-verification-module-scss-module__Czs-8G__disabled",
  "disclaimer": "phone-verification-module-scss-module__Czs-8G__disclaimer",
  "error": "phone-verification-module-scss-module__Czs-8G__error",
  "footer": "phone-verification-module-scss-module__Czs-8G__footer",
  "inputContainer": "phone-verification-module-scss-module__Czs-8G__inputContainer",
  "phoneInput": "phone-verification-module-scss-module__Czs-8G__phoneInput",
  "phoneVerification": "phone-verification-module-scss-module__Czs-8G__phoneVerification",
  "prefillButton": "phone-verification-module-scss-module__Czs-8G__prefillButton",
  "resendButton": "phone-verification-module-scss-module__Czs-8G__resendButton",
  "smsDisclaimer": "phone-verification-module-scss-module__Czs-8G__smsDisclaimer",
  "smsPreferenceButtons": "phone-verification-module-scss-module__Czs-8G__smsPreferenceButtons",
  "tertiaryButton": "phone-verification-module-scss-module__Czs-8G__tertiaryButton",
  "title": "phone-verification-module-scss-module__Czs-8G__title",
  "updatePhoneButton": "phone-verification-module-scss-module__Czs-8G__updatePhoneButton",
  "wrongNumber": "phone-verification-module-scss-module__Czs-8G__wrongNumber",
});
